import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgClass, NgIf, NgOptimizedImage } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ToggleService } from '../header/toggle.service';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
import { FeathericonsModule } from '../../icons/feathericons/feathericons.module';
import { environment } from '../../environments/environment';
import { AuthService } from '../../services/auth.service';
import { Subscription } from 'rxjs';
import { UserInfoService } from '../../services/user.service';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [
        NgScrollbarModule,
        MatExpansionModule,
        RouterLinkActive,
        RouterModule,
        RouterLink,
        NgClass,
        FeathericonsModule,
        MatAccordion,
        NgIf,
        NgOptimizedImage
    ],
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit, OnDestroy {

    constructor(
        private toggleService: ToggleService,
        private authSerice: AuthService,
        private userInfoService: UserInfoService
    ) {
        this.toggleService.isToggledSideBar$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }
    isAdmin = false;

    userSubscription?: Subscription;

    ngOnInit(): void {
      if (this.authSerice.isLoggedIn()) {
        this.userSubscription = this.userInfoService.userInfo$.subscribe({
          next: response => {
            if (!environment.production) {
              console.log(response);
            }
            if (response) {
              this.isAdmin = response.is_admin;
            } else {
              this.isAdmin = false;
            }
          },
          error: error => {
            if (!environment.production) {
              console.log(error);
            }
            this.isAdmin = false;
          }
        });
      }
    }

    ngOnDestroy(): void {
      this.userSubscription?.unsubscribe();
    }

    // Toggle Service
    isToggled = false;
    toggle() {
        this.toggleService.toggleSideBar();
    }

    // Mat Expansion
    panelOpenState = false;

}
